import serverCall from "../../serverCall";

const getAll = (params) => {
  const query = new URLSearchParams(params).toString();
  return serverCall.get(`/admin/contactusplan?${query}`);
};

const approve = (body) => serverCall.post(`/admin/contactusplan/approve`, body);

const ContactPlanService = { getAll, approve };

export default ContactPlanService;
